<section class="content-header" style="padding: 0.5% !important;">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-md-6">
        <ol class="breadcrumb float-sm-left">
          <li class="breadcrumb-item">
            <a [routerLink]="['/admin/']"
              ><i class="fas fa-home"></i> &nbsp;Trang chủ</a
            >
          </li>
          <li class="breadcrumb-item active">Thiết lập thời gian nộp</li>
        </ol>
      </div>
      <div class="col-md-6">
        <button
          [style.display]="'block'"
          id="btnAdd"
          #btnAdd
          class="btn btn-success btn-sm"
          (click)="Insert()"
          style="float: right;"
        >
          <i class="fas fa-plus-circle"></i> Thêm mới
        </button>
        <button
          [style.display]="'none'"
          id="btnEdit"
          #btnEdit
          class="btn btn-warning btn-sm"
          (click)="Update()"
          style="float: right;"
        >
          <i class="fas fa-plus-circle"></i> Cập nhập
        </button>
      </div>
    </div>
  </div>
</section>

<section class="content cus-body" *ngIf="isDisplay">
  <div class="card">
    <div class="card-body">
      <div class="form-horizontal" [formGroup]="Action">
        <div class="row" style="font-family: sans-serif;">
          <div class="col-md-3">
            <label>Hệ</label>
            <ng-select [(ngModel)]="ID_he" formControlName="ID_he">
              <ng-option value="">Chọn hệ</ng-option>
              <ng-option *ngFor="let p of dataHe" [value]="p.ID_he">{{
                p.Ten_he
              }}</ng-option>
            </ng-select>
            <div
              *ngIf="submitted && checkvalue.ID_he.errors"
              class="invalid-feedback"
            >
              <div *ngIf="checkvalue.ID_he.errors.required">
                Chưa chọn hệ!
              </div>
            </div>
          </div>

          <div class="col-md-2">
            <label>Khóa</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="Khoa_hoc"
              placeholder="Khóa học"
              formControlName="Khoa_hoc"
              required
              [ngClass]="{
                'is-invalid': submitted && checkvalue.Khoa_hoc.errors
              }"
            />
            <div
              *ngIf="submitted && checkvalue.Khoa_hoc.errors"
              class="invalid-feedback"
            >
              <div *ngIf="checkvalue.Khoa_hoc.errors.required">
                Khóa học không được bỏ trống!
              </div>
            </div>
          </div>

          <div class="col-md-1">
            <label>Điểm xét TN</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="Diem"
              formControlName="Diem"
              required
              [ngClass]="{
                'is-invalid': submitted && checkvalue.Diem.errors
              }"
            />
            <div
              *ngIf="submitted && checkvalue.Diem.errors"
              class="invalid-feedback"
            >
              <div *ngIf="checkvalue.Diem.errors.required">
                Điểm không được bỏ trống!
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <label>Từ ngày</label>
            <input
              type="date"
              class="form-control"
              [(ngModel)]="Ngay_bat_dau"
              formControlName="Ngay_bat_dau"
              min="{{ minDate }}"
              (change)="lookDateTo()"
              required
              [ngClass]="{
                'is-invalid': submitted && checkvalue.Ngay_bat_dau.errors
              }"
            />
            <div
              *ngIf="submitted && checkvalue.Ngay_bat_dau.errors"
              class="invalid-feedback"
            >
              <div *ngIf="checkvalue.Ngay_bat_dau.errors.required">
                Thời gian không được bỏ trống!
              </div>
              <div *ngIf="checkvalue.Ngay_bat_dau.errors.maxlength">
                Thời gian tối đa 100 ký tự!
              </div>
            </div>
          </div>

          <div class="col-md-3">
            <label>Đến ngày</label>
            <input
              type="date"
              class="form-control"
              [(ngModel)]="Ngay_ket_thuc"
              formControlName="Ngay_ket_thuc"
              min="{{ toDate }}"
              required
              [ngClass]="{
                'is-invalid': submitted && checkvalue.Ngay_ket_thuc.errors
              }"
            />
            <div
              *ngIf="submitted && checkvalue.Ngay_ket_thuc.errors"
              class="invalid-feedback"
            >
              <div *ngIf="checkvalue.Ngay_ket_thuc.errors.required">
                Thời gian không được bỏ trống!
              </div>
              <div *ngIf="checkvalue.Ngay_ket_thuc.errors.maxlength">
                Thời gian tối đa 100 ký tự!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="content cus-body">
  <div class="card">
    <div class="card-body">
      <div class="tab-content">
        <div class="active tab-pane">
          <div
            class="table-responsive"
            style="max-height: 60vh; margin-bottom: 15px;"
          >
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>Tên hệ</th>
                  <th>Khóa</th>
                  <th>Điểm xét TN</th>
                  <th>Ngày bắt đầu</th>
                  <th>Ngày kết thúc</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of dataTable">
                  <td>{{ data.Ten_he }}</td>
                  <td>{{ data.ID_khoa }}</td>
                  <td>{{ data.Diem }}</td>
                  <td>{{ data.Ngay_bat_dau | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ data.Ngay_ket_thuc | date: 'dd/MM/yyyy' }}</td>
                  <td class="text-center">
                    <button
                      class="btn btn-sm btn-warning"
                      (click)="Detail(data)"
                      style="margin-right: 7px;"
                    >
                      <i class="fas fa-edit" title="Sửa"></i>
                    </button>
                    <button
                      class="btn btn-sm btn-danger"
                      (click)="open(DeleteModal, '', 'Delete', data)"
                      style="margin-right: 7px;"
                    >
                      <i class="fas fa-trash-alt"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="dataTable.length == 0">
                  <td colspan="5" class="text-center">Không có kết quả</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<ng-template #DeleteModal let-modal>
  <div class="modal-content">
    <div class="modal-body">
      <div class="icon-box">
        <i
          class="fas fa-trash-alt"
          style="
            color: #f15e5e;
            font-size: 46px;
            display: inline-block;
            margin-top: 13px;
          "
        ></i>
      </div>
      <p
        style="
          color: inherit;
          text-decoration: none;
          font-size: 20px;
          text-align: center;
          font-weight: 600;
          margin-top: 3em;
        "
      >
        Bạn có chắc chắn muốn xóa
      </p>
      <div class="text-center">
        <button type="button" class="btn btn-md btn-success" (click)="Delete()">
          Đồng ý
        </button>
        <button
          type="button"
          class="btn btn-md btn-danger"
          (click)="modal.dismiss('Cross click')"
          style="margin-left: 1em;"
        >
          Hủy bỏ
        </button>
      </div>
    </div>
  </div>
</ng-template>
